import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class SendNotification extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Notifications/SendNotification");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetSystemNotificationsByUserId extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Notifications/GetSystemNotificationByUserId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetSystemNotificationsForUI extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Notifications/GetUserSystemNotificationsForUI");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class MarkAsRead extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Notifications/MarkAsRead");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  SendNotification,
  GetSystemNotificationsByUserId,
  MarkAsRead,
  GetSystemNotificationsForUI,
};
